<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :apiUrl="apiUrl"
      modalSize="lg"
      withoutDelete>

      <template #additionalButton="scope">
        <div class="form-check form-check-inline">
          <b-form-checkbox v-model="scopedFilterData.pns" switch @input="onChangeType">PNS</b-form-checkbox>
          <b-form-checkbox v-model="scopedFilterData.nonPns" switch @input="onChangeType" class="ml-3">
            Non-PNS
          </b-form-checkbox>
        </div>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="scopedFilterData"
      :search="search"
      @onSelectItem="selectedItem = $event"
      @onDblClicked="item => openDetail(item)" />

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()
  },
  data() {
    return {
      apiUrl: '/employee-assignment',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'FullName', label: 'Nama Pegawai', formatter: (value, key, item) => {
          return item.FrontDegree + item.Name + (item.RearDegree ? item.RearDegree : '')
        }},
        { key: 'Position', label: 'Jabatan', formatter: (value, key, item) => {
          return item.EmployeeAssignments[0] ? item.EmployeeAssignments[0].Position.Name : '-'
        }},
        { key: 'Department', label: 'Ruang', formatter: (value, key, item) => {
          return item.EmployeeAssignments[0] ? item.EmployeeAssignments[0].Department.Name : '-'
        }},
        { key: 'Status', label: 'Status', formatter: (value, key, item) => {
          return item.EmployeeAssignments[0] ? item.EmployeeAssignments[0].EmployeeAssignmentType.Name : '-'
        }},
        { key: 'EndContract', label: 'Akhir Kontrak', formatter: (value, key, item) => {

          if (!item.EmployeeAssignments[0]) {
            return
          }

          if (item.EmployeeAssignments[0].End) {
            const monthDiff = this.$helper.calcMonthDiff(new Date(), new Date(item.EmployeeAssignments[0].End))
            const endContract = this.$helper.formatDate(item.EmployeeAssignments[0].End)

            if (monthDiff < 0) {
              return `<span class="badge badge-danger">${endContract}</span>`
            } else if (monthDiff <= 3) {
              return `<span class="badge badge-warning">${endContract}</span>`
            } else {
              return `<span class="badge badge-success">${endContract}</span>`
            }
          } else {
            return '<span class="badge badge-light">PNS</span>'
          }
        }}
      ],
      selectedItem: null,
      search: '',
      scopedFilterData: {
        pns: false,
        nonPns: true
      },
      assignmentHistoryData: [],
      selectedEmployeeId: null,
      selectedEmployeeName: ''
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    onChangeType () {
      this.onRefresh()
    },
    openDetail (item) {
      // this.assignmentHistoryData = (item.constructor === Object) ? item : this.selectedItem
      this.$router.push(`/employee/assignment-history/${item.ID}`)
    }
  }
}
</script>
